module.exports = __webpack_public_path__ + "f98e7dd52b0267f625886ebdf4462d1f.svg";